import { Page } from "@/models/page-models/Page";

export const CurrencyExchange: Page = {
  "path": "currency-exchange",
  "name": "Currency Exchange",
  "props": {
    "data": {
      "title": "Currency Exchange Rates",
      "printable": "FALSE",
      "url": "currency-exchange",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add Exchange Rate",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "copyDefaultForm",
                      "pageFunction": {
                        "name": "copyDefaultForm",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultForm",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData"
                      }
                    },
                    {
                      "executionOrder": 2,
                      "name": "openAddPopup",
                      "pageFunction": {
                        "name": "openAddPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Add Exchange Rate"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "showIf": "fn(MATCH_ROLE,ACCOUNTING_MANAGER)",
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Approved",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.approvedRates.data.rates}})",
              "rows": [
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "dropdown",
                      "variable": "fetchedData.activeRateForm.currency",
                      "label": "Filter By Currency",
                      "items": "[\"USD\",\"EUR\",\"AED\",\"QAR\",\"KWD\",\"BHD\",\"OMR\"]",
                      "dropdownType": "static",
                      "disabled": "FALSE",
                      "onChange": [
                        {
                          "executionOrder": 1,
                          "name": "getApprovedRates"
                        }
                      ]
                    },
                    {
                      "type": "checkbox",
                      "variable": "fetchedData.activeRateForm.showHistory",
                      "label": "Show Historical Rates",
                      "disabled": "FALSE",
                      "onChange": [
                        {
                          "executionOrder": 1,
                          "name": "getApprovedRates"
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Current Active Rates",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.approvedRates.data.rates}}",
                      "items": "fetchedData.approvedRates.data.rates",
                      "headers": [
                        {
                          "value": "foreignCurrency",
                          "text": "Currency"
                        },
                        {
                          "value": "buyRate",
                          "text": "Exchange Rate (SAR)"
                        },
                        {
                          "value": "effectiveDate",
                          "text": "Effective Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.effectiveDate}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "reviewedBy.displayName",
                          "text": "Approved By"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.pendingRates.data.rates}})",
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.pendingRates.data.rates}}),>,0)",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Approvals",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingRates.data.rates",
                      "headers": [
                        {
                          "value": "foreignCurrency",
                          "text": "Currency"
                        },
                        {
                          "value": "buyRate",
                          "text": "Exchange Rate (SAR)"
                        },
                        {
                          "value": "effectiveDate",
                          "text": "Effective Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.effectiveDate}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveRate",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/currency-exchange/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "storeResponse",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "approveRate"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "showApprovedSnackbar",
                                "type": "fnOpenSnackbar",
                                "color": "secondary",
                                "serverMessage": "Exchange Rate Approved Successfully"
                              },
                              "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                              "name": "showApprovedSnackbar"
                            },
                            {
                              "executionOrder": 3,
                              "name": "getApprovedRates",
                              "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)"
                            },
                            {
                              "executionOrder": 4,
                              "name": "getPendingRates",
                              "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "showIf": "fn(MATCH_ROLE,General Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedExchange",
                              "pageFunction": {
                                "name": "copySelectedExchange",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.selectedRate"
                              }
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup",
                              "pageFunction": {
                                "name": "openRejectionPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Reject Exchange Rate"
                              }
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Exchange Rate",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.rejectionReason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "printable": false
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectRate",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/currency-exchange/{{fetchedData.selectedRate._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "storeResponse",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "rejectRate"
                },
                {
                  "executionOrder": 2,
                  "name": "closeRejectionPopup",
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Exchange Rate"
                  }
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "showRejectedSnackbar",
                    "type": "fnOpenSnackbar",
                    "color": "error",
                    "serverMessage": "Exchange Rate Rejected"
                  },
                  "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                  "name": "showRejectedSnackbar"
                },
                {
                  "executionOrder": 3,
                  "name": "getPendingRates",
                  "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Add Exchange Rate",
          "width": "800",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.foreignCurrency",
                  "label": "Foreign Currency",
                  "items": "[\"USD\",\"EUR\",\"AED\",\"QAR\",\"KWD\",\"BHD\",\"OMR\"]",
                  "dropdownType": "static",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.baseCurrency",
                  "label": "BaseCurrency",
                  "items": "[\"SAR\"]",
                  "dropdownType": "static",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.buyRate",
                  "label": "Exchange Rate",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.effectiveDate",
                  "label": "Effective Date",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Add",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "addRate",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/currency-exchange/create",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "storeResponse",
                    "arg3Value": "TRUE"
                  },
                  "name": "rejectRate"
                },
                {
                  "executionOrder": 2,
                  "name": "closeCreatePopup",
                  "pageFunction": {
                    "name": "closeCreatePopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Add Exchange Rate"
                  }
                },
                {
                  "executionOrder": 3,
                  "name": "getPendingRates",
                  "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getApprovedRates"
      },
      {
        "executionOrder": 1,
        "name": "getPendingRates"
      }
    ],
    "functions": [
      {
        "name": "getApprovedRates",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/currency-exchange/active",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.approvedRates",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.activeRateForm"
      },
      {
        "name": "getPendingRates",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/currency-exchange/pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingRates"
      },
      {
        "name": "getDefaultForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "baseCurrency": "SAR",
          "effectiveDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 80
};